import React from 'react';

function ArrowRightIcon() {

	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2181_4860)">
				<path d="M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM4.25806 9.41935C4.03226 9.41935 3.87097 9.25806 3.87097 9.03226V6.96774C3.87097 6.77419 4.03226 6.58065 4.25806 6.58065H8V4.32258C8 3.96774 8.3871 3.77419 8.64516 4.03226L12.3226 7.74194C12.4839 7.90323 12.4839 8.12903 12.3226 8.29032L8.64516 12C8.41935 12.2258 8 12.0645 8 11.7097V9.41935L4.25806 9.41935Z" fill="white"/>
			</g>
			<defs>
				<clipPath id="clip0_2181_4860">
					<rect width="16" height="16" fill="white"/>
				</clipPath>
			</defs>
		</svg>

	);
}

export default ArrowRightIcon;